<template>
  <section
    v-if="open"
    class="fixed bg-secondary/30 w-full h-full inset-0 z-50 overflow-y-auto xl:hidden"
  >
    <div class="bg-white absolute bottom-12 min-h-72 md:h-full md:top-0 pb-3 w-full md:max-w-96">
      <div class="p-3 border-b border-b-gray-100">
        <h3 class="!text-gray-900 font-medium mb-2">
          Document Filters
        </h3>

        <span class="block text-xs leading-snug">You can navigate to a specific outcomes by tapping on one of the items in this list.</span>
      </div>

      <ul>
        <template
          v-for="(title, index) in pageTitles"
          :key="index"
        >
          <li
            class="px-4 py-2.5 cursor-pointer hover:bg-gray-50 duration-150 transition-colors text-xs xl:text-sm"
            :class="{ 'bg-slate-200 font-medium text-gray-900 hover:bg-slate-200': page === index }"
            @click="handleIndexClick(index)"
          >
            {{ title }}
          </li>
        </template>
      </ul>
    </div>
  </section>
</template>

<script setup>
defineProps({
  pageTitles: {
    type: Array,
    default: () => [],
  },
  open: {
    type: Boolean,
    default: false,
  },
});

const page = defineModel('page', { type: Number, default: 0 });
const showIndex = defineModel('showIndex', { type: Boolean });

const handleIndexClick = index => {
  page.value = index;
  showIndex.value = false;

  window.scrollTo(0, 0);
};
</script>
